import type { AllRouteEndpoints } from "../routeTypes";
export const integrationsDirectCdiJobsJobIdSinkLogsRequestExportCacheKeys: AllRouteEndpoints[] = [];
